// @flow
import React, { useState } from 'react';
import type { Element } from 'react';
import { NextSeo } from 'next-seo';
import { DarkCrossIcon } from '@images/svg/index';
import { useBreakpoint } from '@hooks';
import { withTranslation } from '@i18n';
import { YAPITA_HEALTH_URL } from '@routes';
import { TeaserVideo, BannerRight } from '@components';
import HomeTreatmentPlan from '@screens/Home/components/HomeTreatmentPlan/index';
import { BUTTONS } from '@screens/TreatmentCostFlow/illness';
import Advantages from '@screens/AboutUs/Advantages/index';
import HowItWorksVideo from '@components/HowItWorksVideo/index';
// import TeaserSideJob from './components/TeaserSideJob';
import Products from './components/Products/index';
import TPFFlow from './components/TPFFlow/index';
import {
  StyledHeadlineSection,
  StyledWrapper,
  StyledComponentFlexWrapper,
  StyledComponentFlexdiv,
  StyledOuterModalWrapper,
  StyledModalWrapper,
  StyledCross,
  StyledIframe,
  StyledBanner,
  StyledBannerDiv,
  StyledWatchNowMobile,
  StyledBannerText,
  StyledBannerCurefy,
  StyledWatchNow,
  StyledImage,
  StyledBannerMaxWidth
} from './styles';

import type { Props, StaticMetaData } from './types';

const HowItWorksScreen = ({ t }: Props): Element<any> => {
  // $FlowIgnoreQueryImport

  const Mobile: Boolean = useBreakpoint('mobile', 'tablet');
  const Tablet: Boolean = useBreakpoint('tablet', 'desktop');
  const buttons = BUTTONS({ t: key => t(`FlowScreen:${key}`) });

  const [videoUrl, setVideoUrl] = useState();
  const [modalState, setModalState] = useState(false);
  const openModal = () => setModalState(true);
  const closeModal = () => setModalState(false);
  const [videoPlaying, setVideoPlaying] = useState(true);

  const OpenandPlay = () => {
    setVideoPlaying(!videoPlaying);
    openModal();
  };
  const stopAndClose = () => {
    closeModal();
    setVideoPlaying(!videoPlaying);
  };


  const metaData: StaticMetaData = t('Seo:HowItWorks', {
    returnObjects: true
  });

  return (
    <>
      <NextSeo
        title={metaData.MetaTitle}
        description={metaData.MetaDescription}
        canonical={`${YAPITA_HEALTH_URL}/en/how-it-works`}
        openGraph={{
          url: `${YAPITA_HEALTH_URL}/en/how-it-works`,
          title: metaData.MetaTitle,
          description: metaData.MetaDescription,
          images: [
            {
              url:
                'https://yapita-production.s3.ap-south-1.amazonaws.com/images/yapita-health-og.jpg',
              width: 800,
              height: 600,
              alt: 'Yapita Health - Your Medical Partner',
              type: 'image/jpg'
            }
          ],
          siteName: 'Yapita Health'
        }}
        twitter={{
          handle: '@yapitahealth',
          site: '@yapitahealth',
          cardType: 'summary_large_image'
        }}
      />
      <StyledWrapper>
        <StyledHeadlineSection>{t('Title')}</StyledHeadlineSection>

        <TPFFlow Mobile={Mobile || Tablet} />
        <HowItWorksVideo />
        <HomeTreatmentPlan isMobile={Mobile} isTablet={Tablet} buttons={buttons} />
        <StyledBannerMaxWidth>
          <StyledBanner>
            <StyledBannerDiv>
              <StyledBannerText>
                {t('BannerHeadline')}
              </StyledBannerText>
              <StyledWatchNow onClick={() => {
                OpenandPlay();
                setVideoUrl('https://www.youtube.com/embed/8I0q_L3mcIA?si=We3fDWN5QYLZcZM3');
              }}
              >
                {t('WatchNow')}
              </StyledWatchNow>
            </StyledBannerDiv>
            <StyledImage>
              <StyledBannerCurefy src="../../../static/images/svg/BannerCurefy.ai.svg" alt="Banner Curefy" />
            </StyledImage>
            <StyledWatchNowMobile onClick={() => {
              OpenandPlay();
              setVideoUrl('https://www.youtube.com/embed/8I0q_L3mcIA?si=We3fDWN5QYLZcZM3');
            }}
            >
              {t('WatchNow')}
            </StyledWatchNowMobile>
          </StyledBanner>
        </StyledBannerMaxWidth>
        <StyledHeadlineSection videoTitle>{t('VideoTitle')}</StyledHeadlineSection>
        <TeaserVideo
          posterUrl="../../../static/images/HowItWorks/video-poster.jpg"
          alt="Get The Quality Treatment - Yapita Health"
          type="video-stream"
          src="https://yapita-production.s3.ap-south-1.amazonaws.com/images/yapita-how-it-works.mp4"
        />

        {/* <TeaserSideJob /> */}
        <Products />
        <StyledComponentFlexWrapper>
          <StyledComponentFlexdiv>
            <BannerRight
              Mobile={Mobile}
              Tablet={Tablet}
              OpenandPlay={OpenandPlay}
              setVideoUrl={setVideoUrl}
            />
          </StyledComponentFlexdiv>
          <StyledComponentFlexdiv>
            <Advantages />
          </StyledComponentFlexdiv>
        </StyledComponentFlexWrapper>

        {videoPlaying ? <></>
          : (
            <StyledOuterModalWrapper modalState={modalState} onClick={stopAndClose}>
              <StyledModalWrapper modalState={modalState}>
                <StyledCross onClick={stopAndClose}>
                  <DarkCrossIcon />
                </StyledCross>
                <StyledIframe src={videoUrl} />
              </StyledModalWrapper>
            </StyledOuterModalWrapper>
          )}
      </StyledWrapper>
    </>
  );
};

HowItWorksScreen.getInitialProps = async () => ({
  namespacesRequired: ['HowItWorksScreen', 'FAQs']
});

export default withTranslation('HowItWorksScreen')(HowItWorksScreen);
